import { Stack } from '@mui/material';
import { Fragment, useEffect, useState, type ReactElement } from 'react';
import { HomeHero } from '@/features/home/components/HomeHero';
import { RepairsSection } from '@/features/home/components/RepairsSection';
import { UsedDevicesSection } from '@/features/home/components/UsedDevicesSection';
import { homeSectionOrder, type HomeSectionId } from '@/features/home/sectionOrder';
import { getCatalogSupport, type PublicCatalogSupport } from '@/features/operations/api';

/** Public landing (COR-1): two equal calls, Comprar and Vender, then used devices and repairs. */
export function HomePage({ sectionOrder = homeSectionOrder }: { sectionOrder?: HomeSectionId[] }) {
  // Warranty and WhatsApp number enrich the sections but do not gate the page: if they cannot
  // be read, the landing shows without them, as the public sheet does.
  const [support, setSupport] = useState<PublicCatalogSupport | null | undefined>(undefined);

  useEffect(() => {
    let active = true;
    getCatalogSupport()
      .then((value) => {
        if (active) setSupport(value);
      })
      .catch(() => {
        if (active) setSupport(null);
      });
    return () => {
      active = false;
    };
  }, []);

  const sections: Record<HomeSectionId, ReactElement> = {
    used: <UsedDevicesSection warranty={support?.warranty ?? null} />,
    repairs: (
      <RepairsSection
        whatsappNumber={support === undefined ? undefined : (support?.whatsappNumber ?? null)}
      />
    ),
  };

  return (
    <Stack spacing={{ xs: 6, md: 8 }}>
      <HomeHero />
      {sectionOrder.map((id) => (
        <Fragment key={id}>{sections[id]}</Fragment>
      ))}
    </Stack>
  );
}
